import { render, staticRenderFns } from "./ResponsibleUserApprovementReportView.vue?vue&type=template&id=60016261"
import script from "./ResponsibleUserApprovementReportView.vue?vue&type=script&lang=js"
export * from "./ResponsibleUserApprovementReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports